import { useMutation } from '@apollo/client/react';
import { isAuthError } from '@seek/ca-http-client';
import { useEffect, useState } from 'react';

import { useJobId } from 'src/context/useJobId';
import { useGetSignInUrl } from 'src/hooks/useGetSignInUrl';
import { CREATE_LINKOUT_APPLICATION } from 'src/modules/graphql-client/mutations/createApplicationLinkout.graphql';

export function useLinkoutUrl() {
  const { jobId } = useJobId();
  const [error, setError] = useState(null);
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [requireAuth, setRequireAuth] = useState(false);
  const signInUrl = useGetSignInUrl();

  const [createLinkoutApplication] = useMutation(CREATE_LINKOUT_APPLICATION);

  useEffect(() => {
    let ignore = false;
    const fetchUrl = async () => {
      setLoading(true);

      try {
        const response = await createLinkoutApplication({
          variables: {
            jobId,
          },
        });

        if (ignore) {
          return;
        }

        if (!response?.data?.createLinkoutApplication?.applicationUrl) {
          throw new Error('No linkout href');
        }

        setUrl(response.data.createLinkoutApplication.applicationUrl);
      } catch (err: any) {
        if (ignore) {
          return;
        }

        if (isAuthError(err)) {
          setUrl(signInUrl);

          return setRequireAuth(true);
        }

        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUrl();

    return () => {
      ignore = true;
    };
  }, [jobId, signInUrl, createLinkoutApplication]);

  return { url, loading, error, requireAuth };
}
